import {
  array,
  boolean,
  number,
  object,
  string,
  null as zNull,
  type infer as zInfer,
} from "zod";

export const getMintsoftOptions = {
  name: "getMintsoftOptions" as const,
  input: zNull(),
  output: object({
    warehouses: array(
      object({
        id: number(),
        name: string(),
        code: string().optional(),
        active: boolean().optional(),
      }),
    ),
    returnReasons: array(
      object({
        id: number(),
        name: string(),
        stockAction: string().optional(),
        active: boolean().optional(),
      }),
    ),
  }),
};

export type GetMintsoftOptionsOutput = zInfer<typeof getMintsoftOptions.output>;
